import React from 'react'
import {sortable} from 'react-sortable';
import {ListItem} from 'material-ui';

class SortableItem extends React.Component {
    render() {
        return (
            <ListItem {...this.props}>
                {this.props.children}
            </ListItem>
        )
    }
}

export default sortable(SortableItem);


// WEBPACK FOOTER //
// ./src/components/sortable/sortable_item.js